import Slider from "@/components/Slider/Slider";
import Slide from "@/components/Slider/Slide";

export { Slide };
export default Slider;
